<span class="pi pi-spinner loading-spinner" title="This component is still loading"></span>
